import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/components/button';

const propTypes = {
  displayName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  rejectConnection: PropTypes.func.isRequired,
  label: PropTypes.string,
};

const RejectButton = ({displayName, id, rejectConnection, label = 'Remove Connection'}) => (
  <Button
    outline
    size="tiny"
    color="red"
    className="blue-outline connection-information-card-button ml-8"
    aria-label={`${label} ${displayName}`}
    onClick={() => rejectConnection(id)}
  >
    {label}
  </Button>
);

RejectButton.propTypes = propTypes;

export default RejectButton;
